<template>
  <div>
    <template v-if="type!=='brand'">
      <!-- 一级菜单 -->
      <div  v-for="item in menuObject.menuList" :key="item.id">
        <a class="first-menu" @click="queryData(1, item)" href="javascript:void(0)">
          {{ item.name }}
        </a>
        <!-- 二级菜单 -->
        <div>

          <div v-for="secondMenu in item.childrenList" :key="secondMenu.id" class="second-menu-border">
            <a
              :class="{
                'menu-select': secondMenu.id === selectedMenuId && selectedThirdId === ''
              }"
              href="javascript:void(0)"
              @click="queryData(2, secondMenu)"
            >
              {{ secondMenu.collectionName || secondMenu.cateName }}
            </a>
            <!-- 三级菜单 -->
            <div v-if="selectedMenuId === secondMenu.id">
              <div v-for="thirdMenu in thirdList" :key="thirdMenu.id" class="third-menu-border">
                <a
                  href="javascript:void(0)"
                  :class="{ 'menu-select':  thirdMenu.id === selectedThirdId }"
                  @click="queryData(3, thirdMenu)"
                >
                  {{ thirdMenu.cateName ? thirdMenu.cateName : thirdMenu.collectionName }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <!-- 二级菜单 -->
      <div>
        <div>
            <a class="first-menu"   href="javascript:void(0)" @click="queryDataByBrand(-1, null)">
              All Products
            </a>
        </div>
        <div v-for="secondMenu in menuArr" :key="secondMenu.id">
          <a :class="{
               'menu-select': secondMenu.id === selectedMenuId && selectedThirdId === ''
              }" href="javascript:void(0)" @click="queryDataByBrand(2, secondMenu)"
          >
            {{ secondMenu.collectionName || secondMenu.cateName }}
          </a>
          <!-- 三级菜单 -->
          <div v-for="thirdMenu in secondMenu.childrenList" :key="thirdMenu.id" class="cust-brand-menu-border">
            <a
              href="javascript:void(0)"
              :class="{ 'menu-select':  thirdMenu.id === selectedThirdId }"
              @click="queryDataByBrand(3, thirdMenu)"
            >
              {{ thirdMenu.cateName ? thirdMenu.cateName : thirdMenu.collectionName }}
            </a>
          </div>
        </div>
      </div>

    </template>
  </div>
</template>

<script>
export default {
  props: {
    menuObject: {
      type: Object
    },
    menuArr: {
      type: Array
    },
    middleWare: {
      type: Function
    },
    type: {
      type: String
    },
  },
  data() {
    return {
      thirdList: [],
      selectedMenuId: '', // 选中的2级菜单
      selectedThirdId: '', // 选中的3级菜单
      showThird: false,
      title: '',
      isAll:false
    }
  },
  watch: {
    menuObject(n, o) {
      this.defaultSelected()
    }
  },
  created() {
    // 进来之后默认选中，判断 1、2、3级是否为空
    this.defaultSelected()
  },
  methods: {
    queryDataByBrand(level, item) {
      this.isAll=level==-1
      this.selectedMenuId = ''
      this.selectedThirdId = ''
      if (level === 2) {
        this.selectedMenuId = item.id
        this.selectedThirdId = ''
      }else if(level==3){
        this.selectedMenuId = ''
        this.selectedThirdId = item.id
      }
      let selCategoryId = item ? item.id : ''
      this.$emit("cateFun", selCategoryId)
    },
    /**
     * 点击每一级菜单都会调用该方法，完成显示菜单的功能后，还会查询数据
     */
    queryData(level, item) {
      localStorage.setItem('page_form', 'menu')
      localStorage.setItem('isNewProduct', '')
      localStorage.setItem('isNewProductId', '')
      let queryParams = {}
      // 点击1级直接将selectedMenuId赋值为当前的id，二级的下划线和三级都会隐藏掉
      if (level === 1) {
        this.selectedMenuId = item.id
        this.showThird = false
        this.menuObject.secondItem = undefined
        this.menuObject.thirdItem = undefined
        queryParams.firstName = item.seoUrl.split('/').filter(word => word)[0]
      } else if (level === 2) {
        // 如果是2级，则需要将将selectedMenuId赋值为当前的id，然后给3级集合赋值，最后调用查询
        this.selectedMenuId = item.id
        this.thirdList = item.childrenList
        this.selectedThirdId = ''
        this.showThird = false
        this.menuObject.secondItem = item
        this.menuObject.thirdItem = undefined
        let menuLevel = item.seoUrl.split('/').filter(word => word)
        queryParams.firstName = menuLevel[0]
        queryParams.secondName = menuLevel[1]
      } else if (level === 3) {
        // 如果是3级则需要将将selectedMenuId赋值为当前的id,最后查询数据
        this.selectedThirdId = item.id
        this.showThird = true
        this.menuObject.thirdItem = item
        let menuLevel = []
        if (item.seoUrl) {
          menuLevel = item.seoUrl.split('/').filter(word => word)
        } else {
          menuLevel = item.seourl.split('/').filter(word => word)
        }
        queryParams.firstName = menuLevel[0]
        queryParams.secondName = menuLevel[1]
        queryParams.thirdName = menuLevel[2]
      }
      // 如果是collection 就跳到collection路由
      if (item.collectionName || item['barType']==='collection') {
        this.$router.push({name: 'collection', params: queryParams})
      } else {
        this.$router.push({name: 'category', params: queryParams})
      }
    },
    /**
     * 默认选中
     */
    defaultSelected() {
      if (JSON.stringify(this.menuObject) !== '{}') {
        this.thirdList = []
        this.selectedMenuId = ''
        this.selectedThirdId = ''
        // 先判断有没有2级，如果没有二级则直接吧selectedMenuId 赋值为1级的id即可
        if (this.menuObject.secondItem === undefined || this.menuObject.secondItem === null || this.menuObject.secondItem === '') {
          this.selectedMenuId = this.menuObject.menuList[0].id
          // if (this.menuObject.menuList[0].collectionName) {
          //   // 如果有是collection 则给出标题
          //   document.title = this.menuObject.menuList[0].collectionName + '-Shopvidi.com'
          // } else {
          //   document.title = this.menuObject.menuList[0].cateName + ' wholesale & dropshippinng'
          // }
          return ''
        }
        // 无论3级为不为空，这2行都一定会执行(可能从品牌页面来，没有值)
        if(this.menuObject.secondItem){
          this.selectedMenuId = this.menuObject.secondItem.id
          this.thirdList = this.menuObject.secondItem.childrenList
        }
        // haoyuanw add 2021-10-19 动态显示标题
        // if (this.menuObject.secondItem.collectionName) {
        //   // 如果有是collection 则给出标题
        //   document.title = this.menuObject.secondItem.collectionName + '-Shopvidi.com'
        // } else {
        //   document.title = this.menuObject.secondItem.cateName + ' wholesale & dropshippinng'
        // }
        // 如果3级不为空则执行下面代码，如果为空则直接不执行
        if (this.menuObject.thirdItem !== undefined && this.menuObject.thirdItem !== null && this.menuObject.thirdItem !== '') {
          this.selectedThirdId = this.menuObject.thirdItem.id
          // if (this.menuObject.thirdItem.collectionName) {
          // // 如果有是collection 则给出标题
          //   document.title = this.menuObject.thirdItem.collectionName + '-Shopvidi.com'
          // } else {
          //   document.title = this.menuObject.thirdItem.cateName + ' wholesale & dropshippinng'
          // }
          this.showThird = true
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
a{
  font-family: Satoshi;
  text-decoration: none;
  color: #262613;
  font-size: 14px;
  font-weight: 400;
  line-height: 36px;
}

.menu-select,.first-menu{
  font-weight: 500;
  font-family: Satoshi-Medium;

}
.menu-select{
  padding-bottom:2px;
  border-bottom:1px solid #000;
}

.second-menu-border,.third-menu-border  {
  margin: 5px 0px 5px 10px;
}
.cust-brand-menu-border{
  margin: 5px 0px 5px 15px;
}

.el-divider--horizontal {
  width: 100px;
  margin: 0px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/components/left-menu.vue